<!-- 特典を探す 大カテゴリ -->
<template>
  <section class="crly-m-common-search-category-large icon">
    <CrlyMoleculesCommonAccordion
      :contentsHeight="accordionContentsHeight"
      @clickToggle="clickToggle"
    >
      <template v-slot:label>
        <CrlyAtomsCommonSearchCategoryLargeLabel
          :category="category"
          @clickLrgCat="$listeners['clickLrgCat']"
        />
      </template>
      <template v-slot:toggle>
        <div
          class="crly-m-common-search-category-large__toggle crly-toggle-icon"
          :class="{ open: isOpen }"
        ></div>
      </template>
      <template v-slot:contents>
        <ul
          class="crly-m-common-search-category-large__contents"
          ref="content"
          v-if="finishAnimation"
        >
          <!-- 表示が遅くなるため、表示アニメーション完了後に構築する -->
          <CrlyAtomsCommonSearchCategoryMiddle
            v-for="(middleCat, index) in category.list"
            :key="index"
            :category="middleCat"
            :catType="category.catType"
            :lrgCat="
              middleCat.catLrgCd ? middleCat.catLrgCd : category.catLrgCd
            "
            @clickMidCatToggle="clickMidCatToggle"
          />
        </ul>
      </template>
    </CrlyMoleculesCommonAccordion>
  </section>
</template>

<script>
import CrlyMoleculesCommonAccordion from "@crly/components/molecules/common/Accordion.vue";
import CrlyAtomsCommonSearchCategoryLargeLabel from "@crly/components/atoms/common/search/category/LargeLabel.vue";
import CrlyAtomsCommonSearchCategoryMiddle from "@crly/components/molecules/common/search/category/Middle.vue";

export default {
  name: "CrlyMoleculesCommonSearchCategoryLarge",
  components: {
    CrlyMoleculesCommonAccordion,
    CrlyAtomsCommonSearchCategoryLargeLabel,
    CrlyAtomsCommonSearchCategoryMiddle
  },
  props: {
    /**
     * 表示する大カテゴリ
     */
    category: {
      type: Object,
      default: () => ({})
    },
    /**
     * 表示アニメーションが終了したか
     */
    finishAnimation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /**
       * アコーディオン表示エリアの高さ
       */
      accordionContentsHeight: 0,
      /**
       * アコーディオン開閉状態
       */
      isOpen: false
    };
  },
  methods: {
    /**
     * トグルのクリックイベント
     */
    clickToggle(status = !this.isOpen) {
      this.isOpen = status;
      if (status) {
        this.calcHeight(status);
      }
    },
    /**
     * 中カテゴリ表示エリアの高さを計算する
     * @param {Boolean} isOpen 開閉状態
     */
    calcHeight(isOpen) {
      if (isOpen) {
        const dom = this.$refs.content;
        const rect = dom.getBoundingClientRect(); // 要素の座標と幅と高さを取得
        this.accordionContentsHeight = rect.height - 1;
      }
    },
    /**
     * 中カテゴリのトグルクリックイベント
     * @param {Boolean} status 開閉状態
     * @param {Number} height 小カテゴリの高さ
     */
    clickMidCatToggle(status, height) {
      /* 開閉した小カテゴリの高さを増減させる */
      if (status) {
        this.accordionContentsHeight += height;
      } else {
        this.accordionContentsHeight -= height;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/search/category/large.scss";
</style>
